// Tajik translations
export const tg: Record<string, string> = {
  'menu.dashboard': 'Лавҳаи идора',
  'menu.customers': 'Муштариён',
  'menu.products': 'Маҳсулот',
  'menu.users': 'Корбарон',
  'menu.settings': 'Танзимот',
  'menu.logout': 'Баромадан',
  'dashboard.title': 'Лавҳаи идора',
  'dashboard.newOrder': 'Фармоиши нав',
  'order.title': 'Фармоиши нав',
  'order.customer': 'Муштарӣ',
  'order.products': 'Маҳсулот',
  'order.total': 'Ҷамъ',
  'users.title': 'Корбарон',
  'users.name': 'Ном',
  'users.email': 'Почтаи электронӣ',
  'common.yes': 'Ҳа',
  'common.no': 'Не',
  'common.cancel': 'Бекор кардан',
  'common.save': 'Сабт кардан',
  'common.search': 'Ҷустуҷӯ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Воридшавӣ',
  'login.welcome': 'Хуш омадед, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Почтаи электронӣ',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Ҳисоботҳо ва баҳисобгирӣ',
  'menu.systemAndCommunication': 'Система ва алоқа',
};